import React from 'react';
import { Select } from '@chakra-ui/react';

const stages = {
	uniChoice: 'Выбор ВУЗа',
	admission: 'Поступление',
	paperwork: 'Сбор документов',
	audit: 'Проверка',
	loading: 'Загрузка',
	immi: 'Immi',
	eval: 'Эвалюация',
	profile: 'Создание профиля',
	expect: 'Ждем отбор',
	decline: 'Отказ',
	accept: 'Одобрено',
};

export const SecondarySelect = ({ onChange, newSecondary }) => (
	<Select name="stage" {...{ onChange }}>
		{Object.keys(stages).map(key => (
			<option key={key} value={key} selected={key === newSecondary}>
				{stages[key]}
			</option>
		))}
	</Select>
);
